import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import Api from "../components/ApiService";
import { NavLink } from "react-router-dom";
import StringUtils from "../components/StringUtils";
import data_tematica from "../data/tematica.json";
let data_tematica_object = {};
class Indicador extends React.Component {
  constructor(props) {
    super(props);
    let me = this;
    me.setDataTematica();
    me.urlParams = StringUtils.getUrlParams(props.location.search);
    me.state = {
      indicadores: [],
      ficha_info: {
        id: "",
        nombre:
          me.urlParams.tematica != null
            ? me.getTematica(me.urlParams.tematica)
            : "",
        fuente: "",
        dependencia: "",
        unidad: "",
        unidad_sigla: "",
      },
    };
    this.goToFicha = this.goToFicha.bind(this);
  }
  componentDidMount() {
    let me = this;
    Api(
      {
        query: "ANA06",
        marco: me.urlParams.tematica,
      },
      function(items) {
        if (items.ANA06 && items.ANA06.data.length) {
          let _indicadores = {};
          items.ANA06.data.map(function(item, i) {
            let id = item.id_indicador;
            _indicadores[id] = {
              value: item.id_indicador,
              label: item.indicador,
            };
          });
          let _all_indicadores = [];
          Object.keys(_indicadores).map(function(item, i) {
            let _data = _indicadores[item];
            let _child = {};
            _child.id_indicador = _data.value;
            _child.indicador = _data.label;
            let _child_serie = [];
            items.ANA06.data.map(function(child, i) {
              if (_data.value == child.id_indicador) {
                _child_serie.push({
                  id_serie: child.id_serie,
                  serie: child.serie,
                  unidad: child.unidad,
                  sigla: child.sigla,
                });
              }
            });
            _child.series = _child_serie;
            _all_indicadores.push(_child);
          });
          me.setState({ indicadores: _all_indicadores });
        }
      }
    );
  }
  setDataTematica() {
    data_tematica.forEach((item) => {
      data_tematica_object[item.id] = item.nombre;
    });
  }
  getTematica(idTematica) {
    return data_tematica_object[idTematica];
  }
  processingData(region, periodo) {}
  goToFicha(e) {
    e.preventDefault();
    this.props.history.push("./ficha");
  }
  render() {
    let me = this;
    const { indicadores, ficha_info } = this.state;
    return (
      <div className="container">
        <Row>
          <Col>
            <Card className="mt-1">
              <CardBody>
                <Row>
                  <Col xs={12} sm={12} md={3} xl={3}>
                    <img
                      className="image-tematica-size img-thumbnail mx-auto d-block"
                      src={`https://sinia.minam.gob.pe/informacion/imagenes/tematicas/${me.urlParams.tematica}_verde.png`}
                    />
                  </Col>
                  <Col xs={12} sm={12} md={9} xl={9}>
                    <Row className="mt-5">
                      <Col>
                        <p className="h3 font-weight-bold text-secondary">
                          {" "}
                          {ficha_info.nombre}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
                {indicadores.map((item, key) => {
                  return (
                    <Card className="row-buttom-line">
                    <Row className="mt-2 mb-1 ">
                      <Col xs={12} sm={12} md={8} xl={8}>
                        <NavLink className="mt-1"
                          key={item.id_indicador}
                          to={`./ficha?indicador=${item.id_indicador}`}
                        >
                          <p className="h6 text-secondary ml-2">
                            <i className="fas fa-chart-bar"></i>{" "}
                            {item.indicador}
                          </p>
                        </NavLink>
                      </Col>
                      <Col xs={12} sm={12} md={4} xl={4}>
                        <Row className="mt-1 mb-1">
                          {item.series.map(function(child, k) {
                            return (
                              <Col xs={12} sm={12} md={12} xl={12}>
                                <NavLink className="mt-2 ml-1"
                                  key={child.id_serie}
                                  to={`./ficha?serie=${child.id_serie}&indicador=${item.id_indicador}`}
                                >
                                  <p key={k} className="text-secondary ml-2">
                                    <i className="fas fa-chart-line text-primary"></i>{" "}
                                    {child.serie} {" - "}
                                    {child.unidad} {"("}
                                    {child.sigla}
                                    {")"}{" "}
                                  </p>
                                </NavLink>
                              </Col>
                            );
                          })}
                        </Row>
                      </Col>
                    </Row>
                    </Card>
                  );
                })}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Indicador;
